<template>
   
  <div class="d-flex justify-content-center align-items-center h-100 bg-main">
    <div class="row rounded shadow bg-white" id="main">

      <div class="col d-none d-lg-flex justify-content-center align-items-center  col-lg-6 col-xl-7 rounded" id="image-side">
        <img src="../../assets/images/bg-login.png" class="bg" alt="">
      </div>

      <div class="col d-lg-flex justify-content-center align-items-center col-sm-12 col-md-12 col-lg-6 col-xl-5 ">
        
        <div class="row d-flex justify-content-center" id="login-side">

          <div class="row py-4" name="logo">
            <div class="col d-flex justify-content-center">
              <img class="logo" src="../../assets/images/logo-psicoapp-completa.svg" alt="">
            </div>
          </div>

          <div class="row" name="títulos">

            <div class="col">
              <h5 class="orange" v-if="!reset">Olá, bom te ver aqui!</h5>
              <h5 class="orange" v-else>Redefina sua senha</h5>
              <p class="fs-6 fw-light" v-if="!reset"> <small>Acesse o PsicoApp</small> </p>
            </div>            

          </div>

          <div class="row" name="entradas">

            <div class="col">

              <div>
                <div v-if="!checkUserOutput.exists && !checkUserOutput.registered && !reset">
                  <label for="txtEmail" class="form-label">E-mail</label>
                  <input type="email" class="form-control" v-model="email" id="txtEmail" placeholder="nome@exemplo.com" v-on:keyup.enter="checkIfUserExists">
                </div>
                <div v-else class="mb-2">
                  <span v-if="!reset">{{ 'Olá ' + checkUserOutput.name  }}</span>
                </div>
              </div>

              <div v-if="checkUserOutput.exists && !checkUserOutput.registered && !reset">
                <div>
                  <label for="txt" class="form-label">Senha</label>
                  <input type="password" class="form-control" v-model="newPasswordInput.password" id="txtNewPassword" placeholder="Informe sua senha">
                </div> 
                <div>
                  <label for="txtSenha" class="form-label">Confirmar Senha</label>
                  <input type="password" class="form-control" v-model="newPasswordInput.passwordConfirmation" id="txtNewConfirmPassword" placeholder="Confirme sua senha" v-on:keyup.enter="registerPassword">
                </div>            
              </div>

              <div v-if="reset">
                <div>
                  <label for="txt" class="form-label">Senha</label>
                  <input type="password" class="form-control" v-model="resetInput.password" id="txtNewPassword" placeholder="Informe sua nova senha">
                </div> 
                <div>
                  <label for="txtSenha" class="form-label">Confirmar Senha</label>
                  <input type="password" class="form-control" v-model="resetInput.passwordConfirmation" id="txtNewConfirmPassword" placeholder="Confirme sua nova senha" v-on:keyup.enter="resetPassword">
                </div>            
              </div>

              <div v-if="checkUserOutput.exists && checkUserOutput.registered && !reset">                                  
                <div>
                  <label for="txtSenha" class="form-label">Senha</label>
                  <input type="password" class="form-control" v-model="password" id="txtPassword" placeholder="Informe sua senha" v-on:keyup.enter="signIn">
                </div>
                <div class="my-3">
                  <span v-on:click="forgotMyPassword"><a href="#">Esqueci minha senha</a></span>
                </div>
                <div class="my-1 font-bungee">
                  <h5 class="fw-bold orange text-center">{{checkUserOutput.clinicName + " "}}</h5>
                  <h5 class="fw-bold blue text-center">{{checkUserOutput.clinicCodeName}}</h5>  
                </div>                       
              </div>

            </div>

          </div>

          <div class="row" name="buttons">

            <div class="col py-3">
              <button class="btn btn-primary btn-sm rounded-pill w-100" style="background-color: #7DA8FF!important; border-color: #7DA8FF!important;" v-on:click="checkIfUserExists" v-if="!checkUserOutput.exists && !checkUserOutput.registered && !reset">Entrar</button>
              <button class="btn btn-primary btn-sm rounded-pill w-100" v-on:click="registerPassword" v-if="checkUserOutput.exists && !checkUserOutput.registered && !reset">Cadastrar</button>
              <button class="btn btn-primary btn-sm rounded-pill w-100" v-on:click="resetPassword" v-if="reset">Resetar</button>
              <button class="btn btn-primary btn-sm rounded-pill w-100" style="background-color: #7DA8FF!important; border-color: #7DA8FF!important;" v-on:click="signIn" v-if="checkUserOutput.exists && checkUserOutput.registered && !reset">Entrar</button>
              <button class="btn btn-secondary btn-sm rounded-pill w-100 mt-1" v-on:click="uncheckUser" v-if="checkUserOutput.exists && !reset">Voltar</button>
            </div>

          </div>

          <div class="row" name="termos" id="terms">
            
            <div class="col d-flex justify-content-end align-items-center">

              <p class="fs-6 fw-light px-1 item-a"><small><a href="https://psicoapp.4lions.tec.br/terms" target="_blank">Termos de Uso</a></small></p> | 
              <p class="fs-6 fw-light px-1 item-a"><small><a href="https://psicoapp.4lions.tec.br/privacy" target="_blank">Politica de Privacidade</a></small></p>
            </div>                           
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import { useUserStore } from '@/store/user';
import {getInstance} from "../../api/api";
import { showErrorModal, showErrorNotifications, showSuccessModal } from "../../services/popups";
import {emailIsValid} from "../../services/validate";

export default {
  name: 'LoginView',  
  inject:["mySpinner"],
  setup() {
    const userStore = useUserStore();
    return { userStore }
  },
  props: {
    resetId: {
      type: String,      
    }
  },
  mounted() {    
    if (this.resetId) { this.reset = true; }
    else { this.reset = false; }
    this.getPreferences();    
  },
  data(){
    return { 
      api:getInstance(),
      email:"",
      password:"",
      reset: false,
      resetInput: {password:"", passwordConfirmation: ""},
      checkUserOutput:{name:"", clinicName:"", clinicCodeName:"", exists:false, registered:false},
      newPasswordInput: {email:"", password:"", passwordConfirmation:""},
      newPasswordOutput: {id:"", firstTime:false, clinicId:"",  clinicName:"", clinicCodeName:"", name:"", email:"", type:"", token:"", unreadNotifications:0, hasActiveSubscription:false},
      signInOutput: {id:"", clinicId:"", clinicName:"", clinicCodeName:"", name:"", email:"", type:"", token:"", unreadNotifications:0, hasActiveSubscription:false}
    }
  },
  methods: {
    async checkIfUserExists() {
      
      if (!emailIsValid(this.email)) {
        showErrorModal("Email Inválido, verifique!");
        return;
      } 

      this.mySpinner.loading = true;

      try {         
        let response = await this.api.post("v1/User/CheckIfExists", {email:this.email})

        this.mySpinner.loading = false;

        if (response.data.success) {                  
          this.checkUserOutput = response.data.data;
        }
        else {          
          showErrorModal(response.data.message);         
        }
        
      } catch {
        this.mySpinner.loading = false;
        showErrorModal("Erro ao conectar-se com o servidor!");
      }                                                   
    },
    async registerPassword() {            
             
      if (!this.newPasswordInput.password) {
        showErrorModal("Senha inválida!");  
        return;      
      }
      if (!this.newPasswordInput.passwordConfirmation) {
        showErrorModal("Confirmação de senha inválida!");
        return;       
      }
      if (this.newPasswordInput.passwordConfirmation != this.newPasswordInput.password) {
        showErrorModal("As senhas devem ser iguais!");
        return;
      }                 

      this.newPasswordInput.email = this.email;

      this.mySpinner.loading = true;

      try {

        let response  = await this.api.post("v1/User/DefinePassword", this.newPasswordInput)

        this.mySpinner.loading = false;
      
        if (response.data.success) {          
          this.newPasswordOutput = response.data.data;

          this.userStore.setUserCredendials(           
            this.newPasswordOutput.id,
            this.newPasswordOutput.clinicId, 
            this.newPasswordOutput.name, 
            this.newPasswordOutput.email, 
            this.newPasswordOutput.type,
            this.newPasswordOutput.clinicName,
            this.newPasswordOutput.clinicCodeName,
            this.newPasswordOutput.unreadNotifications,
            this.newPasswordOutput.hasActiveSubscription                                              
          );

          this.userStore.signIn(this.newPasswordOutput.token);
          this.savePreferences(this.email);

          if (this.newPasswordOutput.firstTime) {                        
            if (this.newPasswordOutput.type == "Professional") {              
              this.$router.push("/");
            }
            else if (this.newPasswordOutput.type == "Patient") {              
              this.$router.push("/reports");
            }            
          }
          else {
            this.checkUserOutput.exists = true;
            this.checkUserOutput.registered = true;
          }
        }
        else {
          if (response.data.notifications)
            showErrorNotifications(response.data.notifications)
          else
            showErrorModal(response.data.message);          
        }
      } catch {
        this.mySpinner.loading = false;        
      }                        
    },
    async signIn() {      
      if (!emailIsValid(this.email)) {
        showErrorModal("Email Inválido, verifique!");
        return;
      } 

      if (!this.password) {
        showErrorModal("Senha inválida, verifique!");
        return;
      }      

      this.mySpinner.loading = true;

      try {
        let response = await this.api.post("v1/User/SignIn", {email:this.email, password:this.password});

        this.mySpinner.loading = false;

        if (response.data.success) {
          this.signInOutput = response.data.data;

          if(!response.data.data.hasActiveSubscription){
            console.log("Não tem licença ativa, bloquear app aqui");
          }

          this.userStore.setUserCredendials(
            this.signInOutput.id,
            this.signInOutput.clinicId, 
            this.signInOutput.name, 
            this.signInOutput.email, 
            this.signInOutput.type,
            this.signInOutput.clinicName,
            this.signInOutput.clinicCodeName,
            this.signInOutput.unreadNotifications,
            this.signInOutput.hasActiveSubscription                         
          );

          this.userStore.signIn(this.signInOutput.token);   
          this.savePreferences(this.email);                      

          if (this.signInOutput.type == "Professional") {
            this.$router.push("/");
          }
          else if (this.signInOutput.type == "Patient") {            
            this.$router.push("/reports")
          }
            
        }
        else {
          showErrorModal(response.data.message);            
        }

      } catch {
        this.mySpinner.loading = false;        
      }             

    },
    async forgotMyPassword() {
      try {
        this.mySpinner.loading = true;

        // let obj = {
        //   email: this.email
        // }

        let response = await this.api.post("v1/User/ForgotMyPassword", {email:this.email});

        this.mySpinner.loading = false;

        if (!response.data.success) {
          showErrorModal(response.data.message);
        }
        else {
          showSuccessModal(response.data.message);
        }
        
      } catch {
        this.mySpinner.loading = false;        
      }
    },
    async resetPassword() {      

      try {

        if (!this.resetInput.password) {
          showErrorModal("Senha inválida!");  
          return;      
        }
        if (!this.resetInput.passwordConfirmation) {
          showErrorModal("Confirmação de senha inválida!");
          return;       
        }
        if (this.resetInput.passwordConfirmation != this.resetInput.password) {
          showErrorModal("As senhas devem ser iguais!");
          return;
        }            

        this.mySpinner.loading = true;

        let response = await this.api.post("v1/User/ResetPassword", {id:this.resetId, password:this.resetInput.password, passwordConfirmation:this.resetInput.passwordConfirmation});

        this.mySpinner.loading = false;

        if (!response.data.success) {
          if (response.data.notifications) {
            showErrorNotifications(response.data.notifications);
          }
          else {
            showErrorModal(response.data.message);
          }
        }
        else {
          showSuccessModal(response.data.message);
          this.reset = false;
        }
          
      } catch {
          this.mySpinner.loading = false;                
      }
    },
    uncheckUser() {
      this.checkUserOutput.exists = false;
      this.checkUserOutput.registered = false;
    },   
    savePreferences(email) {
      const preferences = {
        email
      }

      localStorage.setItem("preferences", JSON.stringify(preferences));
    },
    getPreferences() {
      const preferences = JSON.parse(localStorage.getItem("preferences"));

      if (preferences) {
        if (preferences.email) {
          this.email = preferences.email;
        }
      }

    }
  }
}
</script>

<style lang="css" scoped>
  @import"../../assets/css/_colors";
  @import"./style.css";    
</style>